import { GetContextMenuItems, GetContextMenuItemsParams, GridReadyEvent } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';
import { StyledAgGrid } from 'src/components/app-components/StyledAgGrid';
import { useSelectRespondentsAgGrid } from '../hooks/useSelectRespondentsAgGrid';

export interface Props<T> {
  rowData: T[];
  onGridReady?: (params: GridReadyEvent) => void;
  onRowDelete?: (data: T | undefined) => void;
  // コンテキストメニュー
  contextMenu?: GetContextMenuItems | undefined;
}

export function SelectRespondentsAgGrid<T extends {}>(props: Props<T>) {
  // Trasration
  const { t } = useTranslation();

  // グリッド定義
  const { columnDefs, defaultColDef } = useSelectRespondentsAgGrid();

  // モーダル外ではこっちを呼び出す。
  const contextMenuItems: GetContextMenuItems = (params: GetContextMenuItemsParams) => {
    if (params.node === null) return [];
    return [
      {
        name: t('button.delete'),
        action: () => {
          if (props.onRowDelete && params.node) {
            props.onRowDelete(params.node.data);
          }
        },
      },
    ];
  };

  return (
    <StyledAgGrid
      defaultColDef={defaultColDef}
      coldef={columnDefs}
      rowSelection={'multiple'}
      rows={props.rowData}
      onGridReady={props.onGridReady}
      contextMenu={props.contextMenu ? props.contextMenu : contextMenuItems}
    />
  );
}
